import React from 'react'

function TableHeader() {
  return (
    // <div style={{"display":'flex',"justifyContent":'space-around'}}>
    //   <h6>Qualification</h6>
    //   <h6>Board/University</h6>
    //   <h6>Year</h6>
    //   <h6>Percentage</h6>
    // </div>
    <div>
      
    </div>
  )
}

export default TableHeader